import React from 'react';
import { render } from 'react-dom';
import App from './App';

import './global.css';

declare global {
	interface Window { bobw_houston: { apiHost: string, appVersion: string, env: string } }
}
window.bobw_houston = window.bobw_houston || {};

render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root'),
);
